// extracted by mini-css-extract-plugin
export default {"actions":"Ingresos_actions__4YVPs","download":"Ingresos_download__OEjLg"};